module.exports = __webpack_public_path__ + "img/type_keine.f4f552a6.svg";